/**
 * given an options list (for a select) and an id, retuns the matching option
 * also considering nested options
 *
 * @param {*} id
 * @param {*} options
 * @returns
 */
export function findOption(id, options) {
  if (!id) {
    return null;
  }
  for (let i = 0; i < options.length; i++) {
    if (options[i].value === id) {
      return options[i];
    }
    if (options[i].options) {
      const found = findOption(id, options[i].options);
      if (found) {
        return found;
      }
    }
  }
}

export const getUserLabel = (i, intl, includeLabel=true) => {
  if (!i) return "-";
  return `${i["name"]}${includeLabel ? ' (' + intl.formatMessage({id: i.role}) + ')' : ''}`;
};


export function getWbsActivities(wbs, id_parent) {
  return wbs.filter((w) => w.id_parent === id_parent);
}


export function numapproved(activities) {
  return activities.reduce(
    (acc, a) => acc + (a.flg_disabled || a.closed_at !== null),
    0
  );
}

export function allapproved(activities) {
  return numapproved(activities) === activities.length;
}

export function activitiesInfo(activities) {
  const numdone = numapproved(activities);
  const total = activities.length;

  return { numdone, total };
}